import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CoordinatorDashboard from "./pages/CoordinatorDashboard";
import CoordinatorKanbanStep from "./pages/CoordinatorKanbanStep";
import StudentAbsencesPage from "./pages/StudentAbsencesPage";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardAnalytics from "./pages/DashboardAnalytics";
import InstructorManagement from "./pages/InstructorManagement";
import GlobalLoader from "./components/GlobalLoader";
import ClassManagement from "./pages/ClassManagement";
import StudentManagement from "./pages/StudentManagement";
import StudentDetails from "./pages/StudentDatails";
import EvasionStudentsPage from "./pages/EvasionStudentsPage";
import AttendanceReportPage from "./pages/AttendanceReportPage";

function App() {
  return (
    <BrowserRouter>
      <GlobalLoader />

      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRole="INSTRUCTOR">
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/students/:id/absences"
          element={
            <ProtectedRoute allowedRole="INSTRUCTOR">
              <StudentAbsencesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/coordinator"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <CoordinatorDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/coordinator/kanban/:step"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <CoordinatorKanbanStep />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <DashboardAnalytics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics/evasions"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <EvasionStudentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics/attendance-report"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <AttendanceReportPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/instructors"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <InstructorManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/classes"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <ClassManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/students"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <StudentManagement />
            </ProtectedRoute>
          }
        />

        <Route
          path="/students/:id/details"
          element={
            <ProtectedRoute allowedRole="COORDINATION">
              <StudentDetails />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
